import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const ContactCTA = () => {
  return (
    <div className="pb-10">
      <motion.div
        className="bg-gradient-to-t from-[#193882] to-blue-900 text-white text-center py-12 mt-16 rounded-xl mx-4 sm:mx-6 md:mx-20 flex flex-col items-center"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
          Looking for IT Professionals?
        </h2>
        <p className="mb-6 text-base sm:text-lg md:text-xl max-w-2xl">
          Are you seeking experts for your business? We are here to help.
        </p>
        <motion.button
          className="bg-[#0D3559] px-8 py-3 rounded-lg shadow-lg hover:bg-[#0D3559] font-semibold max-w-xs w-auto"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <Link to="/contact">Contact Expert</Link>
        </motion.button>
      </motion.div>
    </div>
  );
};

export default ContactCTA;
